<template>
    <div v-resize="onResize">        
        <loader v-if="loading" />       
        <div> 
            <v-data-table 
                v-if="!loading"
                :headers="HEADERS"
                :footer-props="FOOTERS"
                :items="items"
                item-key="$id"       
                :search="search"         
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :expand="expand"
                :hide-actions="isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
                <template v-slot:items="props">
                    <tr v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pb-xs-0"><a target="_blank" :href="props.item.Link">{{ props.item.Title }}</a></h3></div>
                                <div class="flex-item" data-label="Date">{{ props.item.Date | stringDateFormat }}</div>
                                <div class="flex-item" data-label="Minister"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Minister.Phid } }">{{ props.item.Minister.DisplayName }}</router-link></div>
                                <div class="flex-item" data-label="Portfolio">
                                    <div v-for="(portfolio, index) in props.item.Portfolios" :key="index">{{ portfolio }}</div>
                                </div>                                
                                <div class="flex-item" data-label="Tags">
                                    <div v-for="(tag, index) in props.item.Tags" :key="index">{{ tag }}</div>
                                </div>       
                            </div>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="text-xs-left">{{ props.item.Date | stringDateFormat }}</td>
                        <td class="text-xs-left font-weight-bold"><a target="_blank" :href="props.item.Link">{{ props.item.Title }}</a></td>
                        <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Minister.Phid } }">{{ props.item.Minister.DisplayName }}</router-link></td>                        
                        <td class="text-xs-left">
                            <div v-for="(portfolio, index) in props.item.Portfolios" :key="index">{{ portfolio }}</div>
                        </td>                        
                        <td class="text-xs-left">
                            <div v-for="(tag, index) in props.item.Tags" :key="index">{{ tag }}</div>
                        </td>                        
                    </tr>
                </template>
            </v-data-table>    
        </div>   
        <br/>
        <v-layout row wrap class="hidden-print-only">
            <v-flex xs12>
                <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                    <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                    <span>&nbsp;Download CSV</span>
                </v-btn>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>    
    import print from '../mixins/print';
    import Loader from '@/components/Loader.vue';
    import axios from 'axios';    
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        created() {
            this.initialiseItems();
            this.onResize();
        },
        props: ['id', 'search'],
        mixins: [print],
        components: {
            Loader
        },
        data() {
            return {
                expand: false,
                isMobile: false,                
                items: [],
                loading: true,
                csvDownloading: false,
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                    sortBy: 'Date',
                    descending: true
                },
                HEADERS: [
                {
                    text: 'Date',
                    value: 'Date',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Title',
                    value: 'Title',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Minister',
                    value: 'Minister.DisplayName',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Portfolio',
                    value: 'Portfolios',
                    align: 'left'                    
                },               
                {
                    text: 'Tags',
                    value: 'Tags',
                    align: 'left'                    
                }, 
                ],
                FOOTERS: {
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                },
            }
        },
        computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 1060) {
                    this.isMobile = true;
                }
                else {
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            initialiseItems() {
                this.loading = true;
                const url = `MinisterialStatements/MinisterialStatements?mid=${this.id}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.items = response.data;
                        this.loading = false;
                    });
            },
            exportCsv() {
                this.$gtag.event('ministerial statements download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministerial statements csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                const records = this.items.map(i => 
                    ({ 
                        Date: i.Date,
                        Title: i.Title,
                        Minister: i.Minister.DisplayName,                        
                        Portfolio: i.Portfolios.join(', '),
                        Tags: i.Tags.join(', '),
                        Link: i.Link
                    }));
                let headers = this.HEADERS.map(h => h.text);
                const filename = 'Ministerial statements';
                const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            }
        },
    }
</script>